export const estimatedClass = (value,incompleteExtraction) => {
    if (value === Math.round(value) || !incompleteExtraction ) {
      return ""
    } else {
      return "warn"
    }
};



